include ../../../../common/primary/icon/icon.mixin.pug

.fp-card
  .fp-vertical-spacing.-s-xl.-h100.-justify-center
    .fp-vertical-spacing--line.-justify-center
      +fp-icon('gavel', {size: '50'})
    .fp-vertical-spacing--line.-align-center
      .fp-text.-text-lg.-text-semi-bold(data-test='bids') {{ bids }} {{ t('liveAuctionPage.bids', bids) }}
